import { Component } from '@angular/core';

@Component({
    selector: 'app-mp-total-orders',
    imports: [],
    templateUrl: './mp-total-orders.component.html',
    styleUrl: './mp-total-orders.component.scss'
})
export class MpTotalOrdersComponent {}